import { z } from 'zod';

const validationSchema = z.object({
  reAssignToUserId: z.string({ required_error: 'Please select an Agent' }).uuid(),
  privateMessage: z.string().nullable(),
});

export default validationSchema;
